export const REGIONS = ["서울", "부산", "대구", "인천", "광주", "대전", "울산", "세종", "경기", "강원", "충북", "충남", "전북", "전남", "경북", "경남", "제주", "해외"];
export const LOGIN_ID_PATTERN = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/;
export const AGE_RANGES = [
  { label: "10세 미만", value: "0-9" },
  { label: "10대", value: "10-19" },
  { label: "20대", value: "20-29" },
  { label: "30대", value: "30-39" },
  { label: "40대", value: "40-49" },
  { label: "50대", value: "50-59" },
  { label: "60세 이상", value: "60-" },
];
export const normalizeEmail = (value: string) => value.trim().toLowerCase();
export const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)[\x21-\x7e]{8,64}$/;
export function authError(error: any): string {
  const data = error?.response?.data;
  if (typeof data === "string" && !data.includes("<") && data.length < 200) return data;
  if (typeof data?.message === "string") return data.message;
  return "요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.";
}
